'use strict';

var o = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n.default = e;
	return Object.freeze(n);
}

var o__namespace = /*#__PURE__*/_interopNamespace(o);

var i=s=>{let{size:r,fill:C="#0F0F10",rotateBy:t=0}=s,n={transform:typeof t=="string"?t:`rotate(${t}deg)`};return o__namespace.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:r||24,height:r||24,viewBox:"0 0 24 24",fill:"none",style:n},o__namespace.createElement("path",{d:"M20.0306 8.78062L12.5306 16.2806C12.4609 16.3503 12.3782 16.4057 12.2871 16.4434C12.1961 16.4812 12.0985 16.5006 11.9999 16.5006C11.9014 16.5006 11.8038 16.4812 11.7127 16.4434C11.6217 16.4057 11.539 16.3503 11.4693 16.2806L3.9693 8.78062C3.82857 8.63988 3.74951 8.44901 3.74951 8.24999C3.74951 8.05097 3.82857 7.86009 3.9693 7.71936C4.11003 7.57863 4.30091 7.49957 4.49993 7.49957C4.69895 7.49957 4.88982 7.57863 5.03055 7.71936L11.9999 14.6897L18.9693 7.71936C19.039 7.64968 19.1217 7.59441 19.2128 7.55669C19.3038 7.51898 19.4014 7.49957 19.4999 7.49957C19.5985 7.49957 19.6961 7.51898 19.7871 7.55669C19.8781 7.59441 19.9609 7.64968 20.0306 7.71936C20.1002 7.78905 20.1555 7.87177 20.1932 7.96282C20.2309 8.05386 20.2503 8.15144 20.2503 8.24999C20.2503 8.34854 20.2309 8.44612 20.1932 8.53716C20.1555 8.62821 20.1002 8.71093 20.0306 8.78062Z",fill:C}))};

exports.a = i;
